<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
    },
    es: {
    },
  },
  components: {
    Layout,
    VclList,
    Stat,
  },
  data() {
    return {
      table: {
        heade: ["Nome", "E-mail", "Celular", "Data", "Plano", "Status"],
        body: null,
        loading: true,
        errored: false,
        empty: false,
      },

      statData: null,
    };
  },
  mounted() {
    api
      .get("network/clients")
      .then((response) => {
        if (response.data.status == "success") {
          this.table.body = response.data.list;
          this.statData = [
            {
              icon: "bx bx-user",
              title: "Total",
              value: response.data.total,
            },
          ];
        }
      })
      .catch((error) => {
        this.table.errored = error;
      })
      .finally(() => {
        this.table.loading = false;
        if (this.table.body == "" || this.table.body == null) {
          this.table.empty = true;
        }
      });
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Clientes</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
        <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="table.errored">
              Erro ao carregar os dados, tente novamente mais tarde.
            </div>
            <div v-else-if="table.empty">Nenhum registro encontrado.</div>
            <div v-else class="table-responsive">
              <vcl-list v-if="table.loading" class="col-lg-6"></vcl-list>
              <table v-else class="table table-centered table-nowrap">
                <thead class="thead-light">
                  <tr>
                    <th v-for="th in table.heade" :key="th">{{ th }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(td, index) in table.body" :key="index">
                    <td v-for="(data, row) in td" :key="row">
                      <template v-if="row === 'status'">
                        <span v-if="data === 'await_plan'" class="badge badge-default">Aguardando plano</span>
                        <span v-else-if="data === 'plan_chosen'" class="badge badge-default">Plano escolhido</span>
                        <span v-else-if="data === 'await_payment'" class="badge badge-warning">Aguardando pagamento</span>
                        <span v-else-if="data === 'payment_processing'" class="badge badge-danger">Pagamento em processamento</span>
                        <span v-else-if="data === 'payment_pending'" class="badge badge-danger">Pagamento pendente</span>
                        <span v-else-if="data === 'payment_change'" class="badge badge-warning">Pagamento alterado</span>
                        <span v-else-if="data === 'active'" class="badge badge-success">Ativo</span>
                        <span v-else-if="data === 'overdue'" class="badge badge-danger">Vencido</span>
                        <span v-else-if="data === 'suspended'" class="badge badge-danger">Suspenso</span>
                        <span v-else-if="data === 'canceled_client'" class="badge badge-danger">Cancelado pelo cliente</span>
                        <span v-else-if="data === 'canceled_overdue'" class="badge badge-danger">Cancelado por vencimento</span>
                        <span v-else-if="data === 'inactive'" class="badge badge-danger">Inativo</span>
                        <span v-else-if="data === 'deleted'" class="badge badge-danger">Deletado</span>
                      </template>
                      <template v-else>
                        {{ data }}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>